module.exports = __webpack_public_path__ + "img/produto-desincha.e92409ed.png";